import React, { useState, useEffect } from "react";
import dayjs from "dayjs";
import HeaderFooter from "../components/headerFooter";
require("dayjs/locale/th");
dayjs.locale("th");

const columns = [
  { id: "requester", label: "ผู้จอง", align: "center", width: "280px" },
  {
    id: "dateTimeStart",
    label: "วัน - เวลา ที่เริ่ม",
    align: "center",
    width: "280px",
  },  {
    id: "dateTimeEnd",
    label: "วัน - เวลา ที่สิ้นสุด",
    align: "center",
    width: "280px",
  },
  { id: "place", label: "ต้นทาง - ปลายทาง", align: "center", width: "200px" },
  { id: "typeFlight", label: "ประเภท", align: "center", width: "100px" },
  {
    id: "TotalPassenger",
    label: "จำนวนผู้เดินทาง",
    align: "center",
    width: "80px",
  },
];

const CrossAreaPoolCar = (props) => {
  const [listBookingNotSuccess, setListBookingNotSuccess] = useState([]);
  const [listBookingIsSuccess, setListBookingIsSuccess] = useState([]);

  useEffect(() => {
    const formatDate = (date) => dayjs(date).format("D MMM YYYY");
    const formatTime = (time) => dayjs(time).format("HH.mm") + " น.";

    let listBooking = props.booking;

    if (listBooking) {
      const currentDate = new Date().toISOString();
      const listA = [];
      const listB = [];

      listBooking.forEach((booking) => {
        const formattedBooking = {
          bookingId: booking.idCrossAreaCarPoolBooking,
          nameLabel: "ผู้จอง ",
          name: booking.name,
          email: booking.email,
          phone: booking.telephoneMobile,
          startDateLabel: "วันที่เริ่ม ",
          startDate: formatDate(booking.departureDate),
          startTime: `${formatTime(booking.startTime)}-${formatTime(
            booking.endTime
          )}`,
          returnDateLabel: "วันที่สิ้นสุด ",
          returnDate: formatDate(booking.returnDate),
          returnTime: `${formatTime(booking.returnStartTime)}-${formatTime(
            booking.returnEndTime
          )}`,
          fromPlace: booking.fromPlace,
          toPlace: booking.toPlace,
          typeFlight: booking.flight === "oneWay" ? "เที่ยวเดียว" : "ไป-กลับ",
          numberOfPassenger: booking.numberOfPassenger + " คน",
        };

        if (booking.departureDate < currentDate) {
          listA.push(formattedBooking);
        } else {
          listB.push(formattedBooking);
        }
      });

      setListBookingIsSuccess(listA);
      setListBookingNotSuccess(listB);
    }
  }, []);

  return (
    listBookingIsSuccess &&
    listBookingNotSuccess && (
      <HeaderFooter
        columns={columns}
        listBookingIsSuccess={listBookingIsSuccess}
        listBookingNotSuccess={listBookingNotSuccess}
        showHistory={props.showHistory}
        typeOfBooking={props.typeOfBooking}
        onClickCardHandler={props.onClickCardHandler}
      />
    )
  );
};

export default CrossAreaPoolCar;
